import { ScrollWithShadows } from "../utils/ScrollWithShadows";
import { DivisionPill } from "../division/DivisionPill";
import { makeStyles } from "../../providers/makeStyles";
import { useDivisionList } from "../schedule/useDivisionList";

const useStyles = makeStyles(theme => ({
    container: {
        marginTop: theme.spacing(1),
    }
}));

export const ChildEventDivisions = ({ event, eventDivisions }) => {
    const classes = useStyles();
    const divisions = useDivisionList(event.eventDivisions);

    return (
        <ScrollWithShadows className={classes.container}>
            {eventDivisions.map(ed => <DivisionPill key={ed.id} indicator={divisions[ed.division.id]}>{ed.division.name}</DivisionPill>)}
        </ScrollWithShadows>
    );
};
